// extracted by mini-css-extract-plugin
export default {"carouselContainer":"JCarousel_carouselContainer__gZHRU","carouselTrack":"JCarousel_carouselTrack__eUQF7","scroll":"JCarousel_scroll__b6ytV","card":"JCarousel_card__WG6bN"};